export default __webpack_public_path__ + "static/media/scan.7b4a8cdd.svg";